import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectCasinoSoundsOn } from 'containers/App/selectors';
import DrumVideo from '../assets/drum.music.mp4';
import DrumVideoWithoutSound from '../assets/drum.mp4';
import './Drum.css';

const DRUM_VIDEO_WIDTH = 280;
const DRUM_VIDEO_HEIGHT = 267;
const FRAME_LENGTH_MS = 40;
// const DRUM_VIDEO_LENGTH_S = 15.833333;
const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent
);

class Drum extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.interval = null;

    this.videoRef = React.createRef();
    this.bufferRef = React.createRef();
    this.outputRef = React.createRef();

    this.buffer = null;
    this.output = null;

    this.processFrame = this.processFrame.bind(this);
    this.playEventListener = this.playEventListener.bind(this);
    this.endedEventListener = this.endedEventListener.bind(this);
  }

  //  ---------------------------------
  processFrame() {
    this.buffer.drawImage(this.videoRef.current, 0, 0);

    const image = this.buffer.getImageData(
      0,
      0,
      DRUM_VIDEO_WIDTH,
      DRUM_VIDEO_HEIGHT
    );
    const imageData = image.data;
    const alphaData = this.buffer.getImageData(
      0,
      DRUM_VIDEO_HEIGHT,
      DRUM_VIDEO_WIDTH,
      DRUM_VIDEO_HEIGHT
    ).data;

    for (let i = 3, len = imageData.length; i < len; i = i + 4) {
      imageData[i] = alphaData[i - 1];
    }

    this.output.putImageData(
      image,
      0,
      0,
      0,
      0,
      DRUM_VIDEO_WIDTH,
      DRUM_VIDEO_HEIGHT
    );
  }

  playEventListener() {
    clearInterval(this.interval);
    this.interval = setInterval(this.processFrame, FRAME_LENGTH_MS);
  }
  endedEventListener() {
    clearInterval(this.interval);
    this.props.onDrumStopped && this.props.onDrumStopped();
  }

  //  ---------------------------------
  componentDidMount() {
    this.buffer = this.bufferRef.current.getContext('2d');
    this.output = this.outputRef.current.getContext('2d');

    //  add listeners
    this.videoRef.current.addEventListener('play', this.playEventListener);
    this.videoRef.current.addEventListener('ended', this.endedEventListener);
    this.videoRef.current.muted = !this.props.casinoSoundsOn;
    this.videoRef.current.play();
  }

  componentDidUpdate(prevProps) {
    // console.log('Drum.componentDidUpdate', this.props);
    this.videoRef.current.muted = !this.props.casinoSoundsOn;
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.videoRef.current.pause();

    this.buffer = null;
    this.output = null;
    //  remove listeners
    this.videoRef.current.removeEventListener('play', this.playEventListener);
    this.videoRef.current.removeEventListener('ended', this.endedEventListener);
  }

  //  ---------------------------------
  //  render

  render() {
    return (
      <div className="drum-scene">
        <video playsInline ref={this.videoRef} id="drumVideo">
          <source
            src={isSafariBrowser ? DrumVideoWithoutSound : DrumVideo}
            type="video/mp4"
          />
        </video>
        <canvas
          ref={this.bufferRef}
          width={DRUM_VIDEO_WIDTH}
          height={DRUM_VIDEO_HEIGHT * 2}
          className="buffer"
        />
        <canvas
          ref={this.outputRef}
          width={DRUM_VIDEO_WIDTH}
          height={DRUM_VIDEO_HEIGHT}
          className="output"
        />
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  casinoSoundsOn: makeSelectCasinoSoundsOn()
});

export default connect(mapStateToProps)(Drum);
